/*
  The constellation's behaviour. Three jobs, all learned the hard way in the
  prototype:

  1. Phase-lock the cards to the plate. The counter-rotation only cancels the
     plate's rotation while the two animations share a start time. A card that
     begins its animation later — anything that remounts or is added after load
     — stays permanently out of phase and renders rotated, even upside down.

  2. Start the clips. Browsers gate autoplay on the muted ATTRIBUTE, and a
     video that is muted by property alone sits paused at frame zero, looking
     like a still. Set the attribute and ask for playback directly.

  3. Focus. Landing on a frame drains the colour from every other one.
*/
(function () {
  var field = document.querySelector('[data-mu-field]');
  if (!field) return;

  var plate = field.querySelector('.mu-plate');
  var cards = Array.prototype.slice.call(field.querySelectorAll('[data-mu-card]'));

  /* 1 — phase lock */
  function sync() {
    if (!plate || !plate.getAnimations) return;
    var orbit = plate.getAnimations()[0];
    if (!orbit) return;
    cards.forEach(function (card) {
      var upright = card.querySelector('.mu-card__upright');
      if (!upright || !upright.getAnimations) return;
      upright.getAnimations().forEach(function (anim) {
        anim.startTime = orbit.startTime;
      });
    });
  }
  sync();
  requestAnimationFrame(sync);

  /* 2 — clips */
  field.querySelectorAll('[data-mu-clip]').forEach(function (video) {
    video.muted = true;
    video.setAttribute('muted', '');
    var start = function () {
      var played = video.play();
      if (played && played.catch) played.catch(function () {});
    };
    start();
    video.addEventListener('canplay', start);
    video.addEventListener('loadeddata', start);
    document.addEventListener('visibilitychange', start);
  });

  /* 3 — focus */
  function focus(card) {
    cards.forEach(function (c) { c.classList.toggle('is-active', c === card); });
    field.classList.add('is-focused');
  }
  function release() {
    cards.forEach(function (c) { c.classList.remove('is-active'); });
    field.classList.remove('is-focused');
  }

  cards.forEach(function (card) {
    card.addEventListener('mouseenter', function () { focus(card); });
    card.addEventListener('mouseleave', release);
    // Touch has no hover: the tap is what reveals the caption.
    card.addEventListener('click', function (event) {
      if (card.classList.contains('is-active')) return; // let a second tap through
      event.preventDefault();
      focus(card);
    });
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-mu-card]')) release();
  });
})();
